namespace RS.Slots.Paytable.Plugins
{
    /**
     * Hide or show buypass text
     */
    export class BuyPassPlugin extends ExternalHelp.VisitorPlugin
    {
        private _showBuyPass: boolean = false;
        private _single: boolean;
        private _rtps: string[];

        public constructor(page: ExternalHelp.IPage)
        {
            super(page);
            this._rtps = URL.getParameter("RTPs").split("!");
            for (const x of this._rtps)
            {
                if (x == "bpSingle")
                {
                    this._single = true;
                    this._showBuyPass = true;
                }
                else if (x == "bpMin")
                {
                    this._single = false;
                    this._showBuyPass = true;
                }
            }
        }

        public onElementLoaded(element: HTMLElement)
        {
            const eClass = element.className;
            const eID = element.id;
            if (eClass == "buypass")
            {
                if (!this._showBuyPass)
                {
                    ExternalHelp.hideElement(element);
                }
                else if (eID == "rs-bps" && this._single == false)
                {
                    ExternalHelp.hideElement(element);
                }
                else if (eID == "rs-bpm" && this._single == true)
                {
                    ExternalHelp.hideElement(element);
                }
            }

            if (eID == "buypass")
            {
                if (!this._showBuyPass)
                {
                    ExternalHelp.hideElement(element);
                }
            }
        }
    }

    ExternalHelp.pluginRegistry.register(BuyPassPlugin);
}